_options$selectedPlan